import { Box, Typography } from "@mui/material";

export default function ThirdRow() {
  const bulletPoints = [
    "systemów operacyjnych",
    "oprogramowania użytkowego i aplikacyjnego",
    "rozwiązań biznesowych",
    "systemów pocztowych",
    "systemów bazodanowych",
    "technologii sieciowych.",
  ];
  const secondBulletPoints = [
    "działalności bieżącej",
    "planowania innowacji."
  ]
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" }, 
        width: "100%",
        backgroundColor: "#FF9A66",
        paddingTop: { xs: "0", md: "50px" },
      }}
    >
      {/* lewa kolumna w poprzednim ukladzie (teraz jest w komponencie Row) */}

      {/* prawa kolumna */}
      <Box
        sx={{
          backgroundColor: "#FFFFFF",
          flex: { xs: "none", md: "1 1 auto" },
          p: { xs: 2, md: 4 },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 2,
          }}
        >
          Usługi wdrożeniowe, oferowane przez naszą firmę, obejmują planowanie,
          projektowanie oraz implementację ściśle określonych produktów i
          technologii, takich jak systemy: operacyjne, wymiany informacji, baz
          danych, zarządzania sieciami i usług katalogowych. Oferta ta dotyczy
          budowy podstawowej infrastruktury teleinformatycznej.
        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "22px", md: "25px" },
            fontWeight: "bold",
            color: "#29235C",
            mb: 0,
          }}
        >
          Wirtualizacja zasobów serwerowych
        </Typography>

        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 2,
          }}
        >
          Migracja zasobów do nowego środowiska serwerowego z jednoczesnym
          zmniejszeniem liczby serwerów, przy zachowaniu dotychczasowej
          funkcjonalności.
        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "22px", md: "25px" },
            fontWeight: "bold",
            color: "#29235C",
            mb: 0,
          }}
        >
          Optymalizacja i monitorowanie systemów
        </Typography>

        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 2,
          }}
        >
          Utrzymanie rozwiązań i systemów w dobrej kondycji w zakresie
          stabilności, jak i wydajności funkcjonowania.
        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "22px", md: "25px" },
            fontWeight: "bold",
            color: "#29235C",
            mb: 0,
          }}
        >
          Integracja usług katalogowych
        </Typography>

        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 2,
          }}
        >
          Integracja systemów katalogowych prowadząca do połączenia usług
          katalogowych różnych producentów tak, aby zarządzanie zasobami
          odbywało się poprzez jeden system usług katalogowych.
        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "22px", md: "25px" },
            fontWeight: "bold",
            color: "#29235C",
            mb: 0,
          }}
        >
          Migracje
        </Typography>

        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 0,
          }}
        >
          Aktualizacja wersji oprogramowania i/lub zmiana technologii rozwiązań
          w zakresie:
        </Typography>

        <Box component="ul" sx={{ pl: 3, m: 0 }}>
          {bulletPoints.map((item, index) => (
            <Box
              component="li"
              key={index}
              sx={{
                fontFamily: "Segoe UI",
                fontSize: { xs: "18px", md: "20px" },
                color: "#29235C",
                mb: 0,
                "&::marker": {
                  color: "#FF5700",
                },
              }}
            >
              {item}
            </Box>
          ))}
        </Box>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "22px", md: "25px" },
            fontWeight: "bold",
            color: "#29235C",
            mb: 0,
          }}
        >
          Standaryzacje{" "}
        </Typography>

        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 2,
          }}
        >
          Unifikacja zasobów sprzętowych, zasobów oprogramowania oraz procedur
          postępowania w zakresie instalacji, konfiguracji i zarządzania
          zmianami w zasobach sprzętowych oraz programowych.
        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "22px", md: "25px" },
            fontWeight: "bold",
            color: "#29235C",
            mb: 0,
          }}
        >
          Usługi konsultacyjne
        </Typography>

        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 0,
          }}
        >
          Grupa usług doradczych w zakresie:
        </Typography>

        <Box component="ul" sx={{ pl: 3, m: 0 }}>
          {secondBulletPoints.map((item, index) => (
            <Box
              component="li"
              key={index}
              sx={{
                fontFamily: "Segoe UI",
                fontSize: { xs: "18px", md: "20px" },
                color: "#29235C",
                mb: 0,
                "&::marker": {
                  color: "#FF5700",
                },
              }}
            >
              {item}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
